import ScreenDetails from "./ScreenDetails";

export default ScreenDetails;